import React from 'react';
import Lottie from 'react-lottie';
import * as animationData from '../../assets/animations/shrimp_button_loader.json';

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

const ShrimpLottie = props => {
  return <Lottie options={defaultOptions} {...props} />;
};

export default ShrimpLottie;



// WEBPACK FOOTER //
// ./src/components/shared/ShrimpLottie.js